import styled from "styled-components";


export const TextGradient = styled.p`
  background-image: linear-gradient(to right, #00F0FF, #5773FF, #FF007A);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const BorderGradient = styled.div`
  border: double 2px transparent;
  background-image: linear-gradient(#0F0B30, #0F0B30),
  linear-gradient(to right, #00F0FF, #5773FF, #FF007A);
  background-origin: border-box;
  background-clip: content-box, border-box;
`;

export const Button = styled(BorderGradient)`
  color: #fff;
  font-weight: 800;
  width: 140px;
  height: 35px;
  border-radius: 30px;
  padding: 1px;
  align-self: flex-end;
`;

export const ListStyleNone = styled.ul`
  list-style: none;
`;
